// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__z7wcR","textarea":"styles_textarea__2Sydf"};